module.exports = __webpack_public_path__ + "static/media/Chicken Suit Guy.de5ee4ec.jpg";